// extracted by mini-css-extract-plugin
export var button = "_en-4";
export var hasDarkBackground = "_en-7";
export var hasLightBackground = "_en-6";
export var iconWrapper = "_en-0";
export var large = "_en-2";
export var medium = "_en-1";
export var small = "_en-5";
export var xsmall = "_en-3";